export default __webpack_public_path__ + "static/media/Trash.0c2823cc.svg";